/* Easonlin Food — storefront behaviour (2026 rebuild)
   1. 询价台：表单值实时拼到右侧摘要，可复制、可 mailto
   2. 产品样本卡：点一下把品名回填进询价台并滚回去
   3. 表单：邮箱校验 + captcha 兼容的发送态（hCaptcha 存在时不抢按钮）
   4. 进场动效 / header 滚动状态 / 商品页 ?product= 回填
   没有依赖，没有 jQuery。 */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. 询价台 ---------- */
  function initDesk() {
    var form = document.getElementById('el-quote-form');
    if (!form) return;
    var summary = document.getElementById('el-summary');
    var mail = document.getElementById('el-mail');
    var copy = document.getElementById('el-copy');

    function read(name) {
      var el = form.querySelector('[name="contact[' + name + ']"]');
      return el ? el.value : '';
    }

    function briefText() {
      var lines = [
        'Product: ' + read('product'),
        'Target spec: ' + read('spec'),
        'Pack format: ' + read('pack'),
        'Volume per month: ' + read('volume'),
        'Destination port: ' + read('port')
      ];
      var note = read('body');
      if (note.trim()) lines.push('', note.trim());
      return lines.join('\n');
    }

    function sync() {
      if (summary) {
        ['product', 'spec', 'pack', 'volume', 'port'].forEach(function (k) {
          var cell = summary.querySelector('[data-brief="' + k + '"]');
          if (cell) cell.textContent = read(k) || '—';
        });
      }
      if (mail) {
        mail.href = 'mailto:' + (mail.dataset.email || 'lydia@easonlinfood.com') +
          '?subject=' + encodeURIComponent('Quote request: ' + read('product')) +
          '&body=' + encodeURIComponent(briefText());
      }
    }

    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.name.indexOf('contact[') !== 0) return;
      el.addEventListener('input', sync);
      el.addEventListener('change', sync);
    });

    if (copy) {
      copy.addEventListener('click', function () {
        var text = briefText();
        var done = function () {
          copy.textContent = 'Copied';
          setTimeout(function () { copy.textContent = 'Copy as text'; }, 1600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(done, done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = text;
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta);
          done();
        }
      });
    }

    /* 样本卡 → 回填询价台 */
    document.querySelectorAll('.el-sp__load').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sel = form.querySelector('[name="contact[product]"]');
        var want = btn.getAttribute('data-product') || '';
        if (sel && want) {
          Array.prototype.forEach.call(sel.options, function (opt) {
            if (opt.value === want || opt.textContent.trim() === want) sel.value = opt.value;
          });
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        sync();
        var desk = document.getElementById('el-desk');
        if (desk) desk.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (summary) {
          summary.classList.remove('el-flash');
          void summary.offsetWidth;
          summary.classList.add('el-flash');
        }
      });
    });

    sync();
  }

  /* ---------- 2. 表单：验证失败保留填写内容，成功返回后清空 ---------- */
  function formValues(form) {
    var data = {};
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.name.indexOf('contact[') !== 0 || el.type === 'hidden') return;
      if (el.type === 'checkbox') {
        if (!Array.isArray(data[el.name])) data[el.name] = [];
        if (el.checked) data[el.name].push(el.value);
      } else {
        data[el.name] = el.value;
      }
    });
    return data;
  }

  function initFormRecovery() {
    document.querySelectorAll('form[action*="/contact"]').forEach(function (form) {
      var key = 'easonlin-form:' + form.id;
      var state = form.dataset.formState || 'idle';
      var saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
      if (state === 'success') {
        sessionStorage.removeItem(key);
      } else if (saved) {
        Array.prototype.forEach.call(form.elements, function (el) {
          if (!Object.prototype.hasOwnProperty.call(saved, el.name)) return;
          if (el.type === 'checkbox') el.checked = saved[el.name].indexOf(el.value) !== -1;
          else el.value = saved[el.name];
        });
        if (state === 'idle') sessionStorage.removeItem(key);
      }
      form.addEventListener('submit', function () {
        try { sessionStorage.setItem(key, JSON.stringify(formValues(form))); } catch (e) {}
      });
    });
  }

  /* ---------- 2b. 邮箱校验 + 发送态（hCaptcha 存在时不抢按钮） ---------- */
  var TOKEN_SELECTOR = 'input[name="h-captcha-response"], input[name="g-recaptcha-response"], input[name="recaptcha-v3-token"]';

  function captchaPresent(form) {
    if (form.getAttribute('data-hcaptcha-bound') === 'true') return true;
    if (form.getAttribute('data-cptcha') === 'true') return true;
    if (form.querySelector(TOKEN_SELECTOR)) return true;
    var frames = document.querySelectorAll('iframe[src*="hcaptcha"], iframe[src*="recaptcha"]');
    for (var i = 0; i < frames.length; i++) {
      var r = frames[i].getBoundingClientRect();
      if (r.width > 120 && r.height > 60) return true;
    }
    return false;
  }

  function initForms() {
    document.querySelectorAll('form[action*="/contact"]').forEach(function (form) {
      var btn = form.querySelector('button[type="submit"]');
      var label = btn ? btn.innerHTML : '';
      var submitting = false;
      var watchdog = 0;

      function clearSending() {
        submitting = false;
        window.clearTimeout(watchdog);
        if (!btn) return;
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-sending');
        btn.innerHTML = label;
      }

      form.addEventListener('submit', function (ev) {
        var email = form.querySelector('input[type="email"]');
        if (email && email.value && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value)) {
          ev.preventDefault();
          email.focus();
          email.setAttribute('aria-invalid', 'true');
          return;
        }
        if (submitting) { ev.preventDefault(); return; }
        if (captchaPresent(form)) return;

        submitting = true;
        if (btn) {
          btn.setAttribute('aria-busy', 'true');
          btn.textContent = form.dataset.sending || 'Sending…';
        }
        watchdog = window.setTimeout(clearSending, 10000);
      });

      window.addEventListener('pageshow', clearSending);
    });
  }

  /* ---------- 3. 进场动效 ---------- */
  function initReveal() {
    var nodes = document.querySelectorAll('.el-reveal');
    if (!nodes.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ---------- 4. header 滚动状态 ---------- */
  function initHeaderState() {
    var header = document.querySelector('.header-bottom') || document.querySelector('.header-pc');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('el-header-scrolled', window.scrollY > 12);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- 5. 商品上下文、样品地址和原页返回 ---------- */
  function initProcurement() {
    var params = new URLSearchParams(window.location.search);
    var raw = params.get('product');
    if (raw) {
      var value = raw.replace(/-/g, ' ');
      document.querySelectorAll('[data-product-prefill]').forEach(function (input) {
        if (!input.value) input.value = value.charAt(0).toUpperCase() + value.slice(1);
      });
    }
    var pack = params.get('pack');
    if (pack) document.querySelectorAll('[data-pack-prefill]').forEach(function (input) {
      if (!input.value) input.value = pack;
    });
    var type = params.get('request');
    if (['quote', 'sample', 'documents'].indexOf(type) !== -1) {
      document.querySelectorAll('form[action*="/contact"]').forEach(function (form) {
        ['quote', 'sample', 'documents'].forEach(function (name) {
          var box = form.querySelector('[name="contact[request_' + name + ']"]');
          if (box) box.checked = name === type;
        });
      });
    }
    function syncSamples() {
      document.querySelectorAll('form[action*="/contact"]').forEach(function (form) {
        var sample = form.querySelector('[name="contact[request_sample]"]');
        var address = form.querySelector('[data-sample-address]');
        if (address) address.hidden = !(sample && (sample.checked || sample.dataset.urlSelected === 'true'));
      });
    }
    document.querySelectorAll('[name="contact[request_sample]"]').forEach(function (box) {
      box.addEventListener('change', syncSamples);
    });
    if (type === 'sample') {
      document.querySelectorAll('[name="contact[request_sample]"]').forEach(function (box) {
        if (box.checked) box.dataset.urlSelected = 'true';
      });
    }
    document.querySelectorAll('[data-return-to]').forEach(function (input) {
      var form = input.closest('form');
      if (!form || !form.id) return;
      input.value = window.location.pathname + window.location.search + '#' + form.id;
    });
    document.querySelectorAll('[data-source-url]').forEach(function (input) {
      input.value = window.location.href;
    });
    syncSamples();
  }

  /* ---------- 6. 首页菜单与搜索：不依赖 jQuery 和旧主题整包 ---------- */
  function initStorefrontNavigation() {
    if (!document.body.classList.contains('template-index')) return;
    var root = document.documentElement;
    var nav = document.querySelector('.site-nav');
    var desktop = document.querySelector('.header-pc .wrapper-navigation .nav-bar');
    var mobile = document.querySelector('.jas-mb-style .nav-bar');
    var closeButton = document.querySelector('.close-menu-mb');
    var mainMenu = document.querySelector('.main-menu.jas-mb-style');

    function placeNavigation() {
      if (!nav) return;
      var target = window.innerWidth >= 1200 ? desktop : mobile;
      if (target && nav.parentElement !== target) target.appendChild(nav);
      if (window.innerWidth >= 1200) closeOverlays();
    }
    function closeOverlays() {
      root.classList.remove('translate-overlay', 'search-open', 'sidebar-open');
      if (closeButton) closeButton.classList.remove('menu-open');
      document.querySelectorAll('.sub-menu-open').forEach(function (el) { el.classList.remove('sub-menu-open'); });
      if (mainMenu) mainMenu.style.overflow = '';
    }
    document.querySelectorAll('[data-menu-mb-toogle]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        root.classList.toggle('translate-overlay');
        if (closeButton) closeButton.classList.toggle('menu-open', root.classList.contains('translate-overlay'));
        if (!root.classList.contains('translate-overlay')) closeOverlays();
      });
    });
    document.querySelectorAll('[data-toggle-menu-mb]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var menu = button.parentElement && button.parentElement.nextElementSibling;
        if (menu && menu.classList.contains('sub-menu-mobile')) menu.classList.toggle('sub-menu-open');
      });
    });
    document.querySelectorAll('.sub-menu-mobile .menu-mb-title').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (button.parentElement) button.parentElement.classList.remove('sub-menu-open');
      });
    });
    document.querySelectorAll('[data-search-mobile-toggle]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        root.classList.add('search-open');
        var input = document.querySelector('.search-mb input[type="search"], .nav-search input[type="search"]');
        if (input) window.setTimeout(function () { input.focus(); }, 60);
      });
    });
    document.querySelectorAll('.close-search').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        root.classList.remove('search-open');
        document.querySelectorAll('.quickSearchResultsWrap').forEach(function (el) { el.style.display = 'none'; });
      });
    });
    document.querySelectorAll('.wrapper-overlay').forEach(function (el) { el.addEventListener('click', closeOverlays); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeOverlays(); });
    document.addEventListener('click', function (event) {
      if (!event.target.closest('.search-form') && !event.target.closest('[data-search-mobile-toggle]')) root.classList.remove('search-open');
    });
    window.addEventListener('resize', placeNavigation, { passive: true });
    placeNavigation();
  }

  function initStorefrontSearch() {
    if (!document.body.classList.contains('template-index')) return;
    document.querySelectorAll('[data-ajax-search]').forEach(function (root) {
      var form = root.querySelector('form.search-bar');
      var input = root.querySelector('input[name="q"]');
      var panel = root.querySelector('.quickSearchResultsWrap');
      var results = root.querySelector('.header-search__results-wrapper');
      if (!form || !input || !panel || !results) return;
      var timer = 0;
      var request = 0;
      function hide() { panel.style.setProperty('display', 'none', 'important'); }
      input.addEventListener('input', function () {
        document.documentElement.classList.add('search-open');
        window.clearTimeout(timer);
        var query = input.value.trim();
        var current = ++request;
        if (query.length < 2) { hide(); results.replaceChildren(); return; }
        timer = window.setTimeout(async function () {
          try {
            var url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last';
            var response = await fetch(url, { headers: { 'Accept': 'application/json' } });
            if (!response.ok) throw new Error('Search request failed');
            var data = await response.json();
            if (current !== request) return;
            var products = data.resources && data.resources.results && data.resources.results.products || [];
            results.replaceChildren();
            var title = document.createElement('div');
            title.className = 'box-title';
            title.textContent = products.length ? 'Product results' : 'No products found';
            results.appendChild(title);
            products.forEach(function (product) {
              var link = document.createElement('a');
              link.href = product.url;
              link.className = 'el-search-result';
              if (product.image) {
                var image = document.createElement('img');
                image.src = product.image;
                image.alt = product.title;
                image.width = 56;
                image.height = 56;
                link.appendChild(image);
              }
              var text = document.createElement('span');
              text.textContent = product.title;
              link.appendChild(text);
              results.appendChild(link);
            });
            panel.style.setProperty('display', 'block', 'important');
          } catch (error) {
            if (current === request) hide();
          }
        }, 250);
      });
      form.addEventListener('submit', hide);
      root.querySelectorAll('.close-search').forEach(function (button) { button.addEventListener('click', hide); });
      document.addEventListener('keydown', function (event) { if (event.key === 'Escape') hide(); });
    });
  }

  function initWhatsAppNotice() {
    var button = document.querySelector('[data-el-wa-pending]');
    var note = document.querySelector('[data-el-wa-note]');
    if (!button || !note) return;
    var timer = 0;
    button.addEventListener('click', function (event) {
      event.preventDefault();
      note.hidden = false;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { note.hidden = true; }, 3200);
    });
  }

  function initProductGalleryLinks() {
    document.querySelectorAll('.slider-nav a').forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (link.getAttribute('href').charAt(0) === '#') event.preventDefault();
      });
    });
  }

  function boot() {
    initFormRecovery();
    initDesk();
    initForms();
    initReveal();
    initHeaderState();
    initProcurement();
    initStorefrontNavigation();
    initStorefrontSearch();
    initProductGalleryLinks();
    initWhatsAppNotice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
